import $ from "jquery";

export class VideoPlayer {

  constructor(el, timestampEvents = [], callback = null) {
    this.$el = $(el);
    this.videoEl = this.$el.get(0);

    this.timestampEvents = timestampEvents;
    this.lastTriggeredIndex = null;
    this.onEndCallback = callback;

    this.videoEl.addEventListener("timeupdate", (e) => this.onUpdate(e))
    this.videoEl.addEventListener("ended", (e) => this.onEnd(e))
  }

  play() {
    this.videoEl.currentTime = 0;
    this.videoEl.play();
    this.lastTriggeredIndex = null;
  }

  stop() {
    this.videoEl.pause();
  }

  onUpdate(e) {
    const timestampInSeconds = parseFloat(e.target.currentTime);
    console.log("timeupdate", timestampInSeconds)

    for (let i = this.timestampEvents.length - 1; i >= 0; i--) {
      if (timestampInSeconds > this.timestampEvents[i].timestamp) {
        if(this.lastTriggeredIndex !== i) {
          this.timestampEvents[i].callback();
          this.lastTriggeredIndex = i;
          console.log("Video trigger " + i);
        }
        break;
      }
    }
  }

  onEnd(e) {
    // console.log("timeupdate", e)
    if (this.onEndCallback) this.onEndCallback();
  }

  reset() {
    this.videoEl.pause();
    this.lastTriggeredIndex = null;
    this.videoEl.currentTime = 0;
  }

}

